"use client";

import Link from "next/link";
import { useHomeIntro } from "@/contexts/home-intro-context";
import { useRef } from "react";
import { useGSAP } from "@gsap/react";
import gsap from "gsap";
import { SplitText } from "gsap/SplitText";
import { usePathname } from "next/navigation";

gsap.registerPlugin(SplitText);

export default function MainNav() {
  const { hasClickedIntro } = useHomeIntro();
  const navRef = useRef<HTMLElement>(null);
  const pathname = usePathname();
  const isHomePage = pathname === "/";
  const pagesDisabled = process.env.NEXT_PUBLIC_PAGES_DISABLED === "true";

  useGSAP(
    () => {
      if (hasClickedIntro && navRef.current) {
        const links = navRef.current.querySelectorAll("li a");
        const allChars: Element[] = [];

        links.forEach((link) => {
          const split = new SplitText(link, { type: "chars" });
          allChars.push(...split.chars);
        });

        gsap.from(allChars, {
          opacity: 0,
          scale: 2,
          stagger: 0.03,
          duration: 0.5,
          ease: "back.out(1.7)",
          delay: 0,
        });
      }
    },
    { scope: navRef, dependencies: [hasClickedIntro] }
  );

  if (isHomePage && !hasClickedIntro) return null;

  return (
    <nav ref={navRef}>
      <ul 
        className="flex justify-center items-center space-x-7 text-white text-xl uppercase tracking-wide leading-none transition-all duration-300 font-headings-uppercase" 
      >
        {!pagesDisabled && (
          <>
            <li>
              <Link href="/about" prefetch={false} className="cursor-pointer">About</Link>
            </li>
            <li>
              <Link href="/history" prefetch={false} className="cursor-pointer">History</Link>
            </li>
          </>
        )}
        <li>
          <Link href="/collection" prefetch={false} className="cursor-pointer">Collection</Link>
        </li>
      </ul>
    </nav>
  );
}
